import { createSelector } from 'reselect';
import { getProjectListState } from 'src/modules/project-list/selectors/getProjectListState';

export const getProjectListClonning = createSelector([
  getProjectListState,
], (state) => state.clonning);
